import * as React from 'react'
import { withFatalCheck } from '../error/withFatalCheck'
import { tryCatch } from '../../utils/tryCatch'
import * as st from './schedule.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { ScheduleItem } from './scheduleItem'
import { ICollection } from '../../selectors/collections'

interface OwnProps {
  hideHeader?: boolean
}

export const ScheduleValid = tryCatch((props: ICollection & OwnProps) => {
  const { header, cardTitleIds, totalEpisodeSize, collectionType, hideHeader = false } = props
  if ((cardTitleIds || []).length === 0) {
    return null
  }
  return (
    <div className={stUtility.pageSection}>
      {header && !hideHeader && (
        <h1 className={st.header}>
          {' '}
          {header} ({totalEpisodeSize}){' '}
        </h1>
      )}
      <ol className={st.avScheduleList}>
        {cardTitleIds.map((titleId, idx) => (
          <React.Fragment key={`schedule-fragment-${titleId}-${idx}`}>
            <ScheduleItem idx={idx} key={`schedule-item-${titleId}-${idx}`} collectionType={collectionType} titleId={titleId} />
          </React.Fragment>
        ))}
      </ol>
    </div>
  )
})

export const Schedule = withFatalCheck(ScheduleValid)
